import React from 'react';
import './PromptCard.css';

interface PromptCardProps {
  prompt: string;
  onClick: (prompt: string) => void;
}

const PromptCard: React.FC<PromptCardProps> = ({ prompt, onClick }) => {
  return (
    <div
      className="prompt-card"
      onClick={() => onClick(prompt)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(prompt);
        }
      }}
    >
      <div className="prompt-text">{prompt}</div>
      <div className="prompt-icon">→</div>
    </div>
  );
};

export default PromptCard;
